import { CheckIcon } from '@chakra-ui/icons'
import { Badge, HStack, Text } from '@chakra-ui/react'
import { colors, Descendant, isVersion2Draft, TemplateEditorDraft, TemplateKey } from '@hb/shared'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { SolidActionButton } from '../../../Buttons'
import { ProfileTemplateViewModal } from '../../../Templates/ViewedTemplateModal'

const SavedBadge = () => (
  <Badge
    ml={2}
    py={1}
    px={2}
    bg="gray.50"
    color={colors.green.hex}
    textShadow="none"
    boxShadow="1px 1px 3px #00000077">
    <HStack spacing={1}>
      <CheckIcon />
      <Text fontSize="sm">DRAFT SAVED</Text>
    </HStack>
  </Badge>
)

export const DraftView = ({
  templateKey,
  draft,
  name,
}: {
  templateKey: TemplateKey
  draft?: Descendant[] | TemplateEditorDraft
  name: string
}) => {
  const { setViewedTemplateKey, viewedTemplate } = useProfile()
  const selected = viewedTemplate?.type === templateKey
  const draftTemplateId = draft && isVersion2Draft(draft) ? (draft.templateId ?? null) : null
  return (
    <>
      <SolidActionButton
        w="100%"
        justifyContent="space-between"
        onClick={() => setViewedTemplateKey(templateKey, draftTemplateId)}>
        <Text lineHeight={1}>{name}</Text>
        {draft ? <SavedBadge /> : null}
      </SolidActionButton>
      {selected ? <ProfileTemplateViewModal /> : null}
    </>
  )
}
